export default "__VITE_ASSET__DmqvYhfI__"